// extracted by mini-css-extract-plugin
export default {"container":"Siding_container__uC4I-","productListContainer":"Siding_productListContainer__qTDOV","productGrid":"Siding_productGrid__8EG90"};